import { render, staticRenderFns } from "./infrastructure.vue?vue&type=template&id=b428de64&scoped=true"
import script from "./infrastructure.vue?vue&type=script&lang=js"
export * from "./infrastructure.vue?vue&type=script&lang=js"
import style0 from "./infrastructure.vue?vue&type=style&index=0&id=b428de64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b428de64",
  null
  
)

export default component.exports